import {
  hotelInfoRouteParamNames,
  HOTEL_INFO_ROUTE_PATH,
  type IHotelInfoRouteParamName,
} from "@modules/hotel-info-path";

export type ICheckoutParamName =
  | "checkoutId"
  | IHotelInfoRouteParamName
  | "dealKey"
  | "trvContext"
  | "sig"
  | "trvGroup"
  | "tripKey"
  | "requestReview";
export const checkoutParamNames: SameRecord<ICheckoutParamName> = {
  checkoutId: "checkoutId",
  dealKey: "dealKey",
  trvContext: "trvContext",
  sig: "sig",
  trvGroup: "trvGroup",
  tripKey: "tripKey",
  requestReview: "requestReview",
  ...hotelInfoRouteParamNames,
};
export const CHECKOUT_PATH = `${HOTEL_INFO_ROUTE_PATH}/checkout/:${checkoutParamNames.checkoutId}`;
